
import { defineComponent } from 'vue'
import DssIcon from '@/components/atoms/DssIcon.vue'

export default defineComponent({
  components: {
    DssIcon,
  },
})
